import react from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CommonQuillEditor from "common/editor";
import { FormHelperText } from "@mui/material";

function ContentSection({
    formData,
    setFormData,
    errors,
    setErrors,
    contentOpen,
    setContentOpen,
}) {
    return <Accordion expanded={contentOpen} onChange={() => setContentOpen(!contentOpen)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="paneltopesection-content"
        id="paneltopesection-header"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
            Content Section
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box width="100%">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems={"flex-start"}
          >
            <Box
              width={"100%"}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Typography
                variant="body2"
                fontWeight="medium"
                color="#9A9AAF"
                style={{ fontSize: "14px" }}
                name="cityParagraph"
              >
                Paragraph
              </Typography>
            </Box>
            <Box width={"100%"} name={``} className="remove-quill-mb">
              <CommonQuillEditor
                allowHeading={false}
                // allowImage={false}
                // value={faq?.question || ''}
                // onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                value={formData.cityParagraph}
                // error={}
                // helperText
                onChange={(value) => {
                  setErrors((prev) => ({ ...prev, cityParagraph: "  " }));
                  setFormData((prev) => ({
                    ...prev,
                    cityParagraph: value,
                  }));
                }}
              />

              {!!errors.cityParagraph && (
                <FormHelperText error>{errors.cityParagraph}</FormHelperText>
              )}
            </Box>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
}

export default ContentSection;